<template>
  <div>
    <el-form-item label="展示题干">
      <el-input v-model="form.subject"></el-input>
    </el-form-item>
    <el-form-item label="正确题干">
      <el-input v-model="form.answerSubject"></el-input>
    </el-form-item>
    <el-form-item label="图片" v-if="config.image">
      <FileInput v-model="form.image" accept="image/*"></FileInput>
    </el-form-item>
    <el-form-item label="音频" v-if="config.audio">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="音频原文" v-if="config.audioText">
      <PinyinGridInput :text.sync="form.audioText" :pinyin.sync="form.audioPinyin"></PinyinGridInput>
    </el-form-item>
    <el-form-item class="exr-items"  label="选项">
      <div class="exr-item-wrap" v-for="(value, key) in form.items" :key="key">
        <div class="exr-item">
          <el-input v-model="value.tone" placeholder="eg: 12(一声二声) 23(二声三声)"></el-input>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="正确答案" :class="'exr-answer-' + config.items">
      <el-radio v-for="(value, key) in form.items" :key="key" :label="key" v-model="form.answer">{{key + 1}}.{{value.text}}</el-radio>
    </el-form-item>
    <el-form-item label="答案音频" v-if="config.answerAudio">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import basexzt from './base-xzt.js'
  import ShowAnswer from "./ShowAnswer"
  import PinyinGridInput from "@/components/PinyinGridInput"
  export default {
    name: 'XsdForm',
    components: {
      FileInput: require('@/components/FileInput').default,
      ShowAnswer, PinyinGridInput
    },
    mixins: [basexzt]
  }
</script>

<style lang="scss" scoped>
  .exr-items{
    margin-bottom: 20px;
    .exr-item{
      display: flex;
      > .el-radio{
        margin-right: 0;
      }
      > .el-input{
        flex: 1;
        + .el-input{
          margin-left: 8px;
        }
      }
      > .file-input{
        flex: 1;
      }
      > .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 8px;
      }
    }
    .exr-item-wrap + .exr-item-wrap{
      margin-top: 12px;
    }
  }
</style>
